import { createContext, useContext } from 'react'

export interface GlassConfig {
  left: number
  top: number
  width: number
  height: number
}

export const GlassConfigContext = createContext<
  ((config: GlassConfig | null) => void) | null
>(null)

export const useSetGlassConfig = () => useContext(GlassConfigContext)
